import { call, put, takeLatest, select } from 'redux-saga/effects';
import { callWithAuth } from '../sagaApiHelper';
import { addPhoneNumberApi, verifyPhoneNumberApi } from '../../api/apiLists/userProfileApi';
import { showAlert } from '../alertSlice';
import { setUserDetail } from '../authSlice';
import { saveAuthToStorage } from '../../utils/authStorageHelper';
import {
  addPhoneNumberRequest,
  addPhoneNumberStart,
  addPhoneNumberSuccess,
  addPhoneNumberFailure,
  verifyPhoneNumberRequest,
  verifyPhoneNumberStart,
  verifyPhoneNumberSuccess,
  verifyPhoneNumberFailure,
} from '../businessOnboardingSlice';

function* handleAddPhoneNumber(action) {
  try {
    yield put(addPhoneNumberStart());

    const payload = action.payload || {};
    const currentUser = yield select((state) => state.auth.user || {});
    const phoneNumber = payload.phoneNumber;

    const res = yield call(callWithAuth, addPhoneNumberApi, { phoneNumber });

    if (res?.status) {
      const nextUser = {
        ...currentUser,
        phoneNumber: res?.data?.phoneNumber ?? phoneNumber,
        phoneNumberVerified: false,
      };

      yield put(setUserDetail(nextUser));
      yield call(saveAuthToStorage, nextUser);
      yield put(addPhoneNumberSuccess({
        phoneNumber: nextUser.phoneNumber,
        message: res?.data?.message ?? res?.msg ?? 'OTP sent to WhatsApp',
      }));
      yield put(showAlert({
        message: res?.data?.message ?? res?.msg ?? 'OTP sent to WhatsApp',
        type: 'success',
      }));
    } else {
      const errorMessage = res?.errMsg || 'Failed to send OTP';
      yield put(addPhoneNumberFailure(errorMessage));
      yield put(showAlert({ message: errorMessage, type: 'error' }));
    }
  } catch (error) {
    const errorMessage = error.message || 'Failed to send OTP';
    yield put(addPhoneNumberFailure(errorMessage));
    yield put(showAlert({ message: errorMessage, type: 'error' }));
  }
}

function* handleVerifyPhoneNumber(action) {
  try {
    yield put(verifyPhoneNumberStart());

    const payload = action.payload || {};
    const currentUser = yield select((state) => state.auth.user || {});
    const otp = payload.otp;

    const res = yield call(callWithAuth, verifyPhoneNumberApi, { otp });

    if (res?.status) {
      const nextUser = {
        ...currentUser,
        phoneNumber: res?.data?.phoneNumber ?? currentUser.phoneNumber,
        phoneNumberVerified: true,
      };

      yield put(setUserDetail(nextUser));
      yield call(saveAuthToStorage, nextUser);
      yield put(verifyPhoneNumberSuccess({
        message: res?.data?.message ?? res?.msg ?? 'Phone number verified successfully',
      }));
      yield put(showAlert({
        message: res?.data?.message ?? res?.msg ?? 'Phone number verified successfully',
        type: 'success',
      }));
    } else {
      const errorMessage = res?.errMsg || 'Failed to verify phone number';
      yield put(verifyPhoneNumberFailure(errorMessage));
      yield put(showAlert({ message: errorMessage, type: 'error' }));
    }
  } catch (error) {
    const errorMessage = error.message || 'Failed to verify phone number';
    yield put(verifyPhoneNumberFailure(errorMessage));
    yield put(showAlert({ message: errorMessage, type: 'error' }));
  }
}

export default function* businessOnboardingSaga() {
  yield takeLatest(addPhoneNumberRequest.type, handleAddPhoneNumber);
  yield takeLatest(verifyPhoneNumberRequest.type, handleVerifyPhoneNumber);
}
